import React from "react";
import { RSD } from "../lib/api";

const COLORS = {
  RED: "text-brand-red", GREEN: "text-brand-green", ORANGE: "text-brand-orange",
  BLUE: "text-blue-600", PURPLE: "text-purple-600", DEFAULT: "text-slate-600",
};

// Immutable order snapshot renderer (products, options/add-ons, Za?, notes, prices).
// Never renders customer contact data — privacy stays with the caller/API.
export function OrderItemsDetail({ items = [], showPrices = true, testid = "order-items" }) {
  return (
    <div data-testid={testid} className="space-y-2">
      {items.map((it, i) => (
        <div key={i} data-testid={`${testid}-item-${i}`} className="border-b last:border-0 pb-2 last:pb-0">
          <div className="flex items-start justify-between gap-2">
            <p className="font-bold text-sm">{it.quantity}× {it.name}</p>
            {showPrices && (it.line_total !== undefined) && (
              <span className="font-display font-black text-sm shrink-0">{RSD(it.line_total)}</span>
            )}
          </div>
          {it.person_label && <p className="text-xs font-black uppercase text-brand-red">ZA: {it.person_label}</p>}
          {(it.modifiers || []).map((m, j) => (
            <p key={j} className={`text-xs font-semibold ${COLORS[m.color] || COLORS.DEFAULT}`}>• {m.name}</p>
          ))}
          {it.note && <p className="text-xs font-bold text-brand-orange">Napomena: {it.note}</p>}
        </div>
      ))}
    </div>
  );
}
